<template>
    <div :class="{ 'hd-inline': asButton }">
        <!-- Compact button mode: a single "Help Desk" button that opens the contact sheet -->
        <a v-if="asButton" href="javascript:void(0)" class="helpdesk-compact-btn" @click="openSheet">
            <ion-icon name="headset-outline" class="helpdesk-compact-icon"></ion-icon>
            <span class="helpdesk-compact-text">Help Desk</span>
        </a>

        <!-- Default card mode: title + call / whatsapp quick actions -->
        <div v-else class="helpdesk-card">
            <div class="helpdesk-left">
                <ion-icon name="headset-outline" class="helpdesk-icon"></ion-icon>
                <span class="helpdesk-title">Help Desk</span>
            </div>
            <div class="helpdesk-actions">
                <a href="javascript:void(0)" class="helpdesk-btn call" title="Call" @click="onCall">
                    <ion-icon name="call-outline"></ion-icon>
                </a>
                <a href="javascript:void(0)" class="helpdesk-btn wa" title="WhatsApp" @click="onWhatsApp">
                    <ion-icon name="logo-whatsapp"></ion-icon>
                </a>
            </div>
        </div>

        <!-- Send Payment Slip — dedicated WhatsApp action to the designated slip number.
             Unit page only; district/zone/state listing pages don't show this. -->
        <a v-if="showSlipBanner && slipContact" href="javascript:void(0)" class="slip-banner mal-text" @click="sendSlip">
            <ion-icon name="logo-whatsapp" class="slip-icon"></ion-icon>
            <div class="slip-text">
                <div class="slip-title">Attach Payment Slip (Optional)</div>
                <div class="slip-sub mal-text">UPI സ്ക്രീൻഷോട്ട് ഇവിടെ അയക്കാം</div>
            </div>
            <ion-icon name="chevron-forward-outline" class="slip-arrow"></ion-icon>
        </a>

        <!-- Chooser sheet (shown when there is more than one number) -->
        <div class="modal fade action-sheet" :id="modalId" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Help Desk</h5>
                    </div>
                    <div class="modal-body">
                        <div class="action-sheet-content">
                            <div v-for="(n, i) in contacts" :key="i" class="hd-row">
                                <div class="hd-info">
                                    <div class="hd-name">{{ n.label || ('Help Desk ' + (i + 1)) }}</div>
                                    <div class="hd-num">+{{ n.number }}</div>
                                    <div v-if="n.slip" class="hd-slip-note">Send payment slips only to this number</div>
                                </div>
                                <div class="hd-acts">
                                    <a href="javascript:void(0)" class="helpdesk-btn call" title="Call" @click="dial(n.number)">
                                        <ion-icon name="call-outline"></ion-icon>
                                    </a>
                                    <a href="javascript:void(0)" class="helpdesk-btn wa" title="WhatsApp" @click="whatsapp(n.number, n.slip)">
                                        <ion-icon name="logo-whatsapp"></ion-icon>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import $ from "jquery";

// ── Help Desk contacts — edit here. Add as many as needed. ──────────
// country code without "+", e.g. 919876543210
// `slip: true` marks the number designated to receive payment slip forwards.
const HELP_DESK_CONTACTS = [
    { label: 'Help Desk 1', number: '919446404097', slip: true },
    { label: 'Help Desk 2', number: '919946773514' },
    { label: 'Help Desk 3', number: '919495018090' },
];

export default {
    name: "HelpDeskCard",
    props: {
        // optional override; falls back to the shared list above
        numbers: { type: Array, default: null },
        id: { type: String, default: 'helpDeskModal' },
        // District/zone/unit context used to pre-fill the payment-slip WhatsApp message
        context: { type: Object, default: null },
        // Show the "Attach Payment Slip" banner — only on the unit's own page
        showSlipBanner: { type: Boolean, default: false },
        // Render as a compact button (opens the contact sheet) instead of the full card
        asButton: { type: Boolean, default: false },
    },
    computed: {
        contacts() {
            const list = (this.numbers && this.numbers.length) ? this.numbers : HELP_DESK_CONTACTS;
            return list.filter(n => n && n.number);
        },
        modalId() {
            return this.id;
        },
        slipContact() {
            return this.contacts.find(n => n.slip) || null;
        },
    },
    methods: {
        dial(num) {
            this.closeSheet();
            window.location.href = 'tel:+' + num;
        },
        slipMessage() {
            const c = this.context || {};
            const lines = ['Payment slip'];
            if (c.district) lines.push('District: ' + c.district);
            if (c.zone)     lines.push('Zone: ' + c.zone);
            if (c.unit)     lines.push('Unit: ' + c.unit);
            return lines.join('\n');
        },
        whatsapp(num, prefill) {
            this.closeSheet();
            const text = prefill ? '?text=' + encodeURIComponent(this.slipMessage()) : '';
            window.open('https://wa.me/' + num + text, '_blank');
        },
        sendSlip() {
            if (!this.slipContact) return;
            this.whatsapp(this.slipContact.number, true);
        },
        onCall() {
            if (this.contacts.length <= 1) {
                if (this.contacts[0]) this.dial(this.contacts[0].number);
            } else {
                this.openSheet();
            }
        },
        onWhatsApp() {
            if (this.contacts.length <= 1) {
                if (this.contacts[0]) this.whatsapp(this.contacts[0].number, this.contacts[0].slip);
            } else {
                this.openSheet();
            }
        },
        closeSheet() {
            try {
                // eslint-disable-next-line no-undef
                if (typeof bootstrap !== 'undefined' && bootstrap.Modal) {
                    // eslint-disable-next-line no-undef
                    const inst = bootstrap.Modal.getInstance(document.getElementById(this.modalId));
                    if (inst) { inst.hide(); return; }
                }
            } catch (e) { /* fall through */ }
            $('#' + this.modalId).modal('hide');
        },
        openSheet() {
            try {
                // eslint-disable-next-line no-undef
                if (typeof bootstrap !== 'undefined' && bootstrap.Modal) {
                    // eslint-disable-next-line no-undef
                    new bootstrap.Modal(document.getElementById(this.modalId)).show();
                    return;
                }
            } catch (e) { /* fall through */ }
            $('#' + this.modalId).modal('show');
        },
    },
};
</script>
<style scoped>
.helpdesk-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    background: #fff;
    border: 1px solid #eef0f5;
    border-radius: 12px;
    padding: 8px 12px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, .04);
}
.helpdesk-left { display: flex; align-items: center; gap: 7px; min-width: 0; }
.helpdesk-icon { font-size: 20px; color: #1a418c; flex-shrink: 0; }
.helpdesk-title { font-size: 13px; font-weight: 800; color: #27173E; white-space: nowrap; }
.helpdesk-actions { display: flex; gap: 7px; }
.helpdesk-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    color: #fff;
    text-decoration: none;
}
.helpdesk-btn ion-icon { font-size: 18px; }
.helpdesk-btn.call { background: #1a418c; }
.helpdesk-btn.wa { background: #25D366; }

/* Compact button mode */
.hd-inline { display: inline-block; }
.helpdesk-compact-btn {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    background: #1a418c;
    color: #fff;
    border-radius: 24px;
    padding: 8px 16px;
    text-decoration: none;
    font-size: 13px;
    font-weight: 700;
    box-shadow: 0 3px 10px rgba(26, 65, 140, 0.3);
}
.helpdesk-compact-btn:active { transform: scale(0.98); }
.helpdesk-compact-icon { font-size: 18px; }
.helpdesk-compact-text { line-height: 1; }

/* Send Payment Slip banner */
.slip-banner {
    display: flex;
    align-items: center;
    gap: 8px;
    background: #0b6e3e;
    border: 1px solid #0a5c34;
    border-radius: 10px;
    padding: 7px 10px;
    margin-top: 6px;
    text-decoration: none;
    box-shadow: 0 2px 6px rgba(11, 110, 62, 0.35);
}
.slip-icon { font-size: 19px; color: #fff; flex-shrink: 0; }
.slip-text { flex: 1; min-width: 0; }
.slip-title { font-size: 12px; font-weight: 800; color: #fff; line-height: 1.2; }
.slip-sub {
    font-size: 10px;
    color: rgba(255, 255, 255, 0.85);
    margin-top: 1px;
    line-height: 1.25;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.slip-arrow { font-size: 14px; color: rgba(255, 255, 255, 0.85); flex-shrink: 0; }

.hd-slip-note { font-size: 10px; color: #1DCC70; font-weight: 700; margin-top: 2px; }

/* chooser rows */
.hd-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 10px 4px;
    border-bottom: 1px solid #f1f3f7;
}
.hd-row:last-child { border-bottom: none; }
.hd-name { font-size: 14px; font-weight: 700; color: #27173E; }
.hd-num { font-size: 12px; color: #94a3b8; margin-top: 1px; }
.hd-acts { display: flex; gap: 8px; flex-shrink: 0; }
</style>
